import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CircularProgress } from '@mui/material';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';

const CalculationTopUsers = () => {
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [period, setPeriod] = useState('thisMonth');

  useEffect(() => {
    const getTopUsers = async () => {
      setLoading(true);
      setRows([]);
      try {
        const response = await axios({
          method: 'GET',
          url: `/api/v1/admin/getCalculationTopUsers?period=${period}`,
        });
        setRows(response.data?.data?.topUsers || []);
      } catch (err) {
        console.log('Error->', err);
      }
      setLoading(false);
    };

    getTopUsers();
  }, [period]);

  return (
    <>
      <div className="calcTopUsersControls">
        <FormControl>
          <InputLabel id="calc-top-users-period">Period</InputLabel>
          <Select
            size="small"
            labelId="calc-top-users-period"
            value={period}
            label="Period"
            sx={{ width: '150px' }}
            onChange={(e) => {
              setPeriod(e.target.value);
            }}
          >
            <MenuItem value={'1'}>Last 1 day</MenuItem>
            <MenuItem value={'3'}>Last 3 days</MenuItem>
            <MenuItem value={'7'}>Last 7 days</MenuItem>
            <MenuItem value={'30'}>Last 30 days</MenuItem>
            <MenuItem value={'90'}>Last 90 days</MenuItem>
            <MenuItem value={'180'}>Last 180 days</MenuItem>
            <MenuItem value={'365'}>Last 365 days</MenuItem>
            <MenuItem value={'thisMonth'}>This month</MenuItem>
            <MenuItem value={'all'}>All time</MenuItem>
          </Select>
        </FormControl>
      </div>
      <div className="pdfTableGrid calcTopUsersTableGrid">
        <div className="pdfTableGridHeader">
          <div className="pdfTableGridCell">#</div>
          <div className="pdfTableGridCell">Name</div>
          <div className="pdfTableGridCell">Email</div>
          <div className="pdfTableGridCell">Role</div>
          <div className="pdfTableGridCell">Total</div>
        </div>
        {loading ? (
          <div style={{ padding: '1rem' }}>
            <CircularProgress size={24} />
          </div>
        ) : (
          rows.map((row, index) => (
            <div className="pdfTableGridRow" key={row.userId || index}>
              <div className="pdfTableGridCell">{index + 1}</div>
              <div className="pdfTableGridCell">{row.name || '-'}</div>
              <div className="pdfTableGridCell">{row.email || '-'}</div>
              <div className="pdfTableGridCell">{row.role || '-'}</div>
              <div className="pdfTableGridCell">{row.total}</div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default CalculationTopUsers;
